import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { provideRouter, withViewTransitions } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { AuthJwtInterceptorService } from './services/auth-jwt-interceptor.service';
import { NgbDatepickerI18nEs } from './helpers/ngb-datepicker-i18n-es';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideToastr({
      preventDuplicates: true,
      countDuplicates: true
    }),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nEs },
    { provide: HTTP_INTERCEPTORS,
      useClass: AuthJwtInterceptorService,
      multi: true }
  ]
};
